import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
  useContext,
} from "react";
import axios from "axios";
import Select from "react-select";
import { useParams, Link, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  DATA_EXPORT,
  ERROR_MESSAGE,
} from "../../../common/Constant";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import { Box } from "@mui/material";

const OpenPurchaseOrderList = (props) => {
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  let navigate = useNavigate();
  const { CurrencySymbol, FractionDigits, dateFormate } = useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startdate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [enddate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [selectedlocationid, setSelectedLocationID] = useState(
    Number(locationid)
  );

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const handleLocationDropdownChange = (event) => {
    setSelectedLocationID(event?.value);
  };

  const apicall = () => {
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/openpurchaseorderlist?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&filtertext=&startdate=${startdate}&enddate=${enddate}&locationid=${selectedlocationid}&currentlocationid=${locationid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          // const numarr = res.data.ResponseData.map((obj) => {
          //   obj.Name = new String(obj.Name ? obj.Name : "");
          //   obj.ShipVia = Number(obj.ShipVia);
          //   return obj;
          // });
          setResponseData(res.data.ResponseData);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        return res;
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  const columns = useMemo(() => [
    {
      header: "Supplier",
      accessorKey: "Supplier",
    },
    {
      header: "Date",
      accessorKey: "Date",
      Cell: ({ row }) => moment(row.original.Date).format(`${dateFormate.toUpperCase()}`), //h:mm A
    },
    {
      header: "Num",
      accessorKey: "Num",
    },
    {
      header: "Memo / Description",
      accessorKey: "MemoDescription",
    },
    {
      header: "ShipVia",
      accessorKey: "ShipVia",
    },
    {
      header: "Amount",
      accessorKey: "Amount",
      Cell: ({ row }) => {
        const amount = row?.original?.Amount;
        if (amount == "0.00" || amount == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(amount),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
        // <div style={{ textAlign: "end" }}>
        //   {Number(row.original.Amount ? row.original.Amount : 0).toFixed(2)}
        // </div>
      },
      Footer: ({ table }) => {
        // Calculate the total for the column
        const totalAmount = table.getRowModel().rows.reduce((sum, row) => {
          const rawAmount = row.original?.Amount || "0";
          const cleanAmount = parseFloat(
            rawAmount.toString().replace(/,/g, "")
          ); // Remove commas if any
          return sum + (isNaN(cleanAmount) ? 0 : cleanAmount);
        }, 0);

        const formattedTotal = !isNaN(totalAmount)
          ? CurrencySymbols(
              Number(totalAmount).toFixed(FractionDigits),
              { CurrencySymbol },
              FractionDigits
            )
          : "N/A";

        console.log({
          totalAmount,
          formattedTotal,
          rows: table.getRowModel().rows,
        });

        return (
          <Box sx={{ textAlign: "right", fontWeight: "bold", padding: "8px" }}>
            {formattedTotal}
          </Box>
        );
      },
    },
    {
      header: "Open Balance",
      accessorKey: "OpenBalance",
      Cell: ({ row }) => {
        const openBalance = row?.original?.OpenBalance;
        if (openBalance == "0.00" || openBalance == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(openBalance),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
      Footer: ({ table }) => {
        // Calculate the total for the column
        const totalAmount = table.getRowModel().rows.reduce((sum, row) => {
          const rawAmount = row.original?.OpenBalance || "0";
          const cleanAmount = parseFloat(
            rawAmount.toString().replace(/,/g, "")
          ); // Remove commas if any
          return sum + (isNaN(cleanAmount) ? 0 : cleanAmount);
        }, 0);

        const formattedTotal = !isNaN(totalAmount)
          ? CurrencySymbols(
              Number(totalAmount).toFixed(FractionDigits),
              { CurrencySymbol },
              FractionDigits
            )
          : "N/A";

        console.log({
          totalAmount,
          formattedTotal,
          rows: table.getRowModel().rows,
        });

        return (
          <Box sx={{ textAlign: "right", fontWeight: "bold", padding: "8px" }}>
            {formattedTotal}
          </Box>
        );
      },
    },
    {
      header: "Account",
      accessorKey: "Account",
    },
    {
      header: "CreatedUser",
      accessorKey: "CreatedUser",
    },
    {
      header: "Created Date",
      accessorKey: "CreatedDate",
      Cell: ({ row }) =>
        moment(row.original.CreatedDate).format(`${dateFormate.toUpperCase()} hh:mm A`),
    },
    {
      header: "Delivery Address",
      accessorKey: "DeliveryAddress",
    },
    {
      header: "LastModified User",
      accessorKey: "LastModifiedUser",
    },
    {
      header: "LastModified Date",
      accessorKey: "LastModifiedDate",
      Cell: ({ row }) => {
        const transactionDate = moment(row.original.LastModifiedDate);
        if (transactionDate.isValid()) {
          return moment(transactionDate).format("MM/DD/YYYY hh:mm A");
        } else {
          return "";
        }
      },
    },
    {
      header: "PO Status",
      accessorKey: "POStatus",
      size: "120",
      filterFn: "contains",
    },
    {
      header: "Split Account",
      accessorKey: "SplitAccount",
    },
  ]);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const locationDropdownOption = [
    { label: "All", value: 0 }, // Adding "All" option
    ...locationdropdown.map((u) => ({ label: u.Name, value: u.Id })),
  ];

  const muiTableBodyRowProps = ({ row }) => ({
    // console.log(row, "checkthis");
    onClick: () => {
      window.open(`/receiving-receipt/${row.original.ID}`, "_blank");
    },
    sx: { cursor: "pointer" },
  });

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3>Open Purchase Order List</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Open Purchase Order List
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Locations
              </label>
              <div className="col-md-12 z-3">
                <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  options={locationDropdownOption}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  // isClearable={true}
                  name="location"
                  id="location"
                  value={locationDropdownOption.find(
                    (e) => e.value === selectedlocationid
                  )}
                  onChange={(event) => {
                    handleLocationDropdownChange(event);
                  }}
                  className="custom-search-select"
                ></Select>
              </div>
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>

          {/* Receipt */}
          {responseData.length > 0 && (
            <div className="card mt-3" id="print">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <h6 className="P">SonarPos</h6>
                    <p className="fw-bold p-regular">
                      Open Purchase Order List
                    </p>
                    <div className="row mb-2 p-regular">
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  <CommonMatrialReactTable
                    MainHeading="Sonar POS"
                    ReportHeading="Open Purchase Order list"
                    columns={columns}
                    data={responseData}
                    startdate={startdate}
                    enddate={enddate}
                    columnGrouping={["Supplier"]}
                    enableExpandAll={true}
                    enableExpanding={true}
                    expanded={true}
                    columnsVisibility={{
                      SplitAccount: false,
                      POStatus: false,
                      LastModifiedUser: false,
                      LastModifiedDate: false,
                      DeliveryAddress: false,
                      CreatedUser: false,
                      CreatedDate: false,
                      Account: false,
                    }}
                    muiTableBodyRowProps={muiTableBodyRowProps}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default OpenPurchaseOrderList;
